export const AUTOSAVE_CONFIG = {
  IS_TOASTR_ACCEPTED: {
    key: 'isToastrAccepted',
    value: {
      true: 'true',
      false: 'false'
    }
  }
};
